import { BaseAuthService } from './BaseAuthService';
import { BACKEND_ROOT } from '../../config/host-config';
import { NotificationService } from '../../services';

export class TypeaheadService extends BaseAuthService {
    private endpointRoot = `${BACKEND_ROOT}/api/typeahead`;
    private notificationService: NotificationService;

    constructor(notificationService: NotificationService) {
        super();
        this.notificationService = notificationService;
    }

    getUserTypeaheadsByOrganization(organizationId: number, filter: string) {
        const endpoint = `${this.endpointRoot}/usersByOrganization?id=${organizationId}&filter=${filter}`;

        return this.runTypeahead(endpoint);
    }

    getUserTypeaheadsByRole(organizationId: number, filter: string) {
        const endpoint = `${this.endpointRoot}/usersByRole?id=${organizationId}&filter=${filter}`;

        return this.runTypeahead(endpoint);
    }

    getTeamTypeaheadsByOrganization(organizationId: number, filter: string) {
        const endpoint = `${this.endpointRoot}/teamsByOrganization?id=${organizationId}&filter=${filter}`;

        return this.runTypeahead(endpoint);
    }

    getOrganizations(filter?: string) {
        let endpoint = `${this.endpointRoot}/organizations`;

        if (filter) {
            endpoint = `${endpoint}?filter=${filter}`;
        }

        return this.runTypeahead(endpoint);
    }

    runTypeahead(uri: string) {
        const init = this.buildRequestInit('GET');

        return fetch(uri, init)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                const message = `Error retrieving typeahead data.`;
                this.notificationService.addError(message);
                throw new Error(message);
            });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/TypeaheadService.tsx